import React from 'react';
import { View, StyleSheet } from 'react-native';
import WorkshopCreditReportScreen from './WorkshopCreditReportScreen';

export const CreditReportScreen = () => {
  return (
    <View style={styles.container}>
      <WorkshopCreditReportScreen />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
